import WelcomeStep from "./WelcomeStep";
import EnergyLevelStep from "./EnergyLevelStep";
import WordStep from "./WordStep";
import CongratsStep from "./CongratsStep";

const steps = [WelcomeStep, EnergyLevelStep, WordStep, CongratsStep];

export default steps;
